// Who waits at a public table, told to a player who is not in the lobby only where the game is over or where they looked
// themselves (owner 2026-11-01: never during a solo game): the win window's line, the Menu's count. Asked at those
// moments only, no timer and no socket per visitor. Any failure means nobody waits.
import { env } from '../env';

export interface Waiter {
  id: string;
  game: string;
  variant: string;
  name: string;
  flag?: string;
  since: number;
}

export async function fetchWaiting(): Promise<Waiter[]> {
  try {
    const res = await fetch(`${env.fullAddr}mp-waiting.json`, { credentials: 'omit' });
    const body = res.ok ? ((await res.json()) as { tables?: unknown }) : null;
    return Array.isArray(body?.tables) ? (body.tables as Waiter[]) : [];
  } catch {
    return [];
  }
}

/** The one to name after a win of `game` (a variant id): that variant first, then its family, then the longest waiting. */
export function waiterFor(list: Waiter[], game: string): Waiter | null {
  const family = game.split(':')[0];
  return list.find((w) => w.variant === game) ?? list.find((w) => w.game === family) ?? list[0] ?? null;
}
